import { openChatPane, type OpenChatPaneOptions } from 'owa-copilot-dab/lib/utils/openChatPane';
import type { OpenBizChatSidePaneParams } from 'owa-bizchat-types';

/**
 * Specific variation of `openChatPane` that always executes the prompt.
 */
export const executePrompt = (
    promptText: OpenChatPaneOptions['promptText'],
    // Also known as "CMM ID"
    formCode: OpenBizChatSidePaneParams['formCode']
): void => {
    openChatPane({
        params: {
            formCode,
            shouldExecuteQuery: true,
        },
        promptText,
    });
};
